import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { DataTable } from '@/components/ui/table/data-table';
import useMembers from '@/hooks/useMembers';

import { createColumns } from './columns';
import { Plugin } from '../../types';

interface PluginsTableProps {
  plugins: Plugin[];
  isLoading: boolean;
  canWrite: boolean;
  canDelete: boolean;
  onEdit: (plugin: Plugin) => void;
  onDelete: (plugin: Plugin) => void;
  onToggleActive: (plugin: Plugin) => void;
  activeRowId?: string;
}

export const PluginsTable = ({
  plugins,
  isLoading,
  canWrite,
  canDelete,
  onEdit,
  onDelete,
  onToggleActive,
  activeRowId,
}: PluginsTableProps) => {
  const { t } = useTranslation();
  const { getMember } = useMembers();

  const columns = useMemo(
    () => createColumns({ onEdit, onDelete, onToggleActive, getMember, canWrite, canDelete }),
    [onEdit, onDelete, onToggleActive, getMember, canWrite, canDelete]
  );

  return (
    <DataTable.Root
      fill
      className="min-h-0 flex-1"
      columns={columns}
      data={plugins}
      rowCount={plugins.length}
      isLoading={isLoading}
      resourceName="event-notifications"
      emptyStateMessage={t('developer_tools.event_notifications_no_results')}
      getRowId={(row) => row.plugin_id}
      activeRowId={activeRowId}
      onRowClick={onEdit}
      enableRowHover
      autoResetPageIndex
    >
      <DataTable.Content />
      <DataTable.Pagination />
    </DataTable.Root>
  );
};
